__turbopack_context__.v({
  "chevron": "CurrencySwitcher-module__83abHG__chevron",
  "chevronOpen": "CurrencySwitcher-module__83abHG__chevronOpen",
  "menu": "CurrencySwitcher-module__83abHG__menu",
  "option": "CurrencySwitcher-module__83abHG__option",
  "optionActive": "CurrencySwitcher-module__83abHG__optionActive",
  "optionCode": "CurrencySwitcher-module__83abHG__optionCode",
  "optionName": "CurrencySwitcher-module__83abHG__optionName",
  "pill": "CurrencySwitcher-module__83abHG__pill",
  "pillActive": "CurrencySwitcher-module__83abHG__pillActive",
  "pills": "CurrencySwitcher-module__83abHG__pills",
  "root": "CurrencySwitcher-module__83abHG__root",
  "trigger": "CurrencySwitcher-module__83abHG__trigger",
});
